export default "__VITE_ASSET__QWV3owPW__"